import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const getRelationIconClass = (type, crm = 3, isActive = true) => {
  if (crm === 4 && isActive) return 'fa rel-type-icon fa-building';
  if (crm === 4 && !isActive) return 'fa rel-type-icon fa-building text-danger';

  return classNames('fa rel-type-icon', {
    'fa-industry': type === 0,
    'fa-briefcase': type === 1,
    'fa-user': type === 2,
    'text-danger': !isActive,
  });
};

const RelationTypeIcon = ({ type, crm, isActive, className, ...rest }) => (
  <i
    className={classNames(
      'fa-fw margin5R fa-inline',
      getRelationIconClass(type, crm, isActive),
      className,
    )}
    {...rest}
  />
);

RelationTypeIcon.propTypes = {
  type: PropTypes.number.isRequired,
  crm: PropTypes.number,
  isActive: PropTypes.bool,
  className: PropTypes.string,
};

export default React.memo(RelationTypeIcon);
